import type { CmpHider } from './types';

export const onetrust: CmpHider = {
  id: 'onetrust',
  label: 'OneTrust / CookiePro',
  css: `
      /* OneTrust / CookiePro (free tier): the whole consent UI — floating cookie
         icon, banner, preferences modal, and dark-filter backdrop — lives inside
         #onetrust-consent-sdk. Hide that root and release the scroll-lock the
         preferences modal applies via a body class. */
      #onetrust-consent-sdk { display: none !important; }
      html body.ot-overflow-hidden {
        overflow: visible !important;
        position: static !important;
      }
  `,
};
